/**
 * @desc 获取资源
 */

import Api from '../../path';
import { fetchData } from '@umu/umu-fetch';

export enum ResourceParentType {
    PARENT_TYPE_GROUP = 1, // 课程
    PARENT_TYPE_FOLDER = 2, // 文件夹
    PARENT_TYPE_PROGRAM = 3, // 学习项目
    PARENT_TYPE_ELEMENT = 4, // 小节
    PARENT_TYPE_QUESTION = 5, // 问题，实际存储的是作业小节的资源
    PARENT_TYPE_CLASS = 6, // 班级
    PARENT_TYPE_HOMEWORK_EVAL_QUESTION = 7, // 多维度评价问卷
    PARENT_TYPE_HOMEWORK_EVAL_QUESTION_TEMPLATE = 8, // 多维度评价问卷模板
    PARENT_TYPE_HOMEWORK_EVAL_ANSWER = 9, // 多维度评价问卷选项
    PARENT_TYPE_HOMEWORK_EVAL_ANSWER_TEMPLATE = 10, // 多维度评价问卷选项模板
    PARENT_TYPE_HOMEWORK_EVAL_QUESTION_UMU_TEMPLATE = 11, // 多维度评价问卷umu模板
    PARENT_TYPE_HOMEWORK_EVAL_ANSWER_UMU_TEMPLATE = 12, // 多维度评价问卷选项umu模板
    PARENT_TYPE_ELEMENT_RESULT = 13, // 小节结果页
    PARENT_TYPE_HOMEWORK_GRAFFITI_FEEDBACK = 14, // 作业圈划点评
}

interface IInput {
    parent_id: string;
    parent_type: ResourceParentType;
}

interface IOutput<T> {
    resource_list: T[];
}

export const fetchResourceList = <T>(data: IInput): Promise<IResponse<IOutput<T>>> => {
    return fetchData(Api.GET_RESOURCE_LIST_V2, data).then((res: IResponse<IOutput<T>>) => {
        return res;
    });
};
